import "core-js/modules/esnext.iterator.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
import { log } from '@/component-create/utils/log';
import * as Icons from '@element-plus/icons-vue';

import { computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'XIcon',
  props: {
    icon: {}
  },
  setup(__props) {
    const prop = __props;
    const icon = computed(() => {
      if (prop.icon.includes('el-icon-')) {
        const key = prop.icon.replace('el-icon-', '').split('-').map(item => item[0].toLocaleUpperCase() + item.slice(1)).join('');
        if (!Icons[key]) {
          log('XIcon', `该图标不存在：${prop.icon}`, 'error');
          return null;
        }
        return Icons[key];
      }
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      return _unref(icon) ? (_openBlock(), _createBlock(_component_el_icon, {
        key: 0
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(_unref(icon))))]),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});